import { DataBean } from "../DataBean";

export class SSTPeriod extends DataBean {

    public async getSSTPeriodCatalogPorPropiedades(properties: any, maxRows: any): Promise<any> {
        return this.getCustomService("SafetyErp", "java.util.List_getSSTPeriodCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

}